module.exports = __webpack_public_path__ + "static/media/jlo.a0cf3c08.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/client_logos/jlo.png
// module id = 275
// module chunks = 0